<div class="offerPreview" *ngIf="offer">
  <div class="offerPreview-pdf">
    <app-pdf-preview
      [offerTitle]="offerTitle"
      [offerDocumentId]="offer.documentId"
      [offerRevision]="offer.revision"
      [pdfSrc]="pdfSrc"
      [isDealer]="isDealer"
      [offerPrice]="offer?.dealerBuyPrice"
      (pdfReady)="setPdfReady($event)"
    ></app-pdf-preview>
  </div>
  <div class="offerPreview-aside">
    <div class="offerPreview-headline">
      <h2 class="h4">{{ 'MODALS.OFFER_PREVIEW.SETTINGS.STEP_TITLE' | translate}}</h2>
    </div>

    <form *ngIf="formReady" [formGroup]="form" class="offerPreview-form">

      <div>
        <app-radio [mainForm]="form" [controlName]="'content'" [options]="radioData.contentTypes" [labelKey]="'title'"
          [valueKey]="'value'" [layoutMod]="['w50', 'stitched']">
        </app-radio>
      </div>

      <div class="toggle-btns">
        <div>
          <app-checkbox [mainForm]="form" [controlName]="'hidePictures'" [labelKey]="'title'"
            [options]="[{ isChecked: form.controls.hidePictures.value, title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.DISPLAY_PICTURES' }]"
            [layoutMod]="['toggle']">
          </app-checkbox>
          <app-checkbox [mainForm]="form" [controlName]="'hideConditions'" [labelKey]="'title'"
            [options]="[{ isChecked: form.controls.hideConditions.value, title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.HIDE_DISCOUNTS' }]"
            [layoutMod]="['toggle']">
          </app-checkbox>
        </div>
        <div>
          <app-checkbox [mainForm]="form" [controlName]="'hidePrices'" [labelKey]="'title'"
            [options]="[{ isChecked: form.controls.hidePrices.value, title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.HIDE_PRICES' }]"
            [layoutMod]="['toggle']">
          </app-checkbox>
          <app-checkbox [mainForm]="form" [controlName]="'showElementPriceOnly'" [labelKey]="'title'"
            [options]="[{ isChecked: form.controls.showElementPriceOnly.value, title: 'FORMS.BRANCH.OFFER_TEMPLATE_SETTINGS.SHOW_ELEMENT_PRICE_ONLY' }]"
            [layoutMod]="['toggle']">
          </app-checkbox>
        </div>
      </div>

      <div class="offerPreview-template">
        <div class="offerPreview-templateSection">
          <h6 class="copy_tiny copy_normal">{{ 'MODALS.OFFER_PREVIEW.SETTINGS.TEXT_TEMPLATE' | translate}}</h6>
          <app-dropdown [mainForm]="form" [controlName]="'templates'" [options]="templates" [labelKey]="'name'"
          [valueKey]="'id'">
          </app-dropdown>
        </div>
        <div class="offerPreview-templateSection">
          <h6 class="copy_tiny copy_normal">{{ 'MODALS.OFFER_PREVIEW.SETTINGS.TEXT_TEMPLATE_T1' | translate}}</h6>
          <app-text-editor [mainForm]="form" [controlName]="'text'"></app-text-editor>
        </div>
        <div class="offerPreview-templateSection">
          <h6 class="copy_tiny copy_normal">{{ 'MODALS.OFFER_PREVIEW.SETTINGS.TEXT_TEMPLATE_T2' | translate}}</h6>
          <app-text-editor [mainForm]="form" [controlName]="'text2'"></app-text-editor>
        </div>
      </div>

    </form>

  </div>
</div>
